import React from 'react';
import { slideWrapper } from '../components/slide';
import { Timer } from '../components/timer';
import { PuzzleItem, PuzzleItemsWrapper } from '../components/puzzle-item';
import { Content } from '../components/content';

export const ArtHousePuzzle9 = slideWrapper(({ data, step, getImg }) => {
  const { answers } = step;

  return (
    <>
      <Content yNotCenter top={20} left={15}>
        <img style={{ transform: 'scaleX(-1)' }} width="400px" src={getImg('mari')} />
      </Content>
      <Timer data={data} presentation />
      <PuzzleItemsWrapper>
        <PuzzleItem getImg={getImg} letterWrapper="t1" letter="a" answers={answers} />
        <PuzzleItem getImg={getImg} letterWrapper="t3" letter="b" answers={answers} />
        <PuzzleItem getImg={getImg} letterWrapper="t4" letter="c" answers={answers} />
      </PuzzleItemsWrapper>
    </>
  );
});
